var _path, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckCircleGreenDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 3.83325C10.7997 3.83325 3.33301 11.2999 3.33301 20.4999C3.33301 29.6999 10.7997 37.1666 19.9997 37.1666C29.1997 37.1666 36.6663 29.6999 36.6663 20.4999C36.6663 11.2999 29.1997 3.83325 19.9997 3.83325Z",
    fill: "#8EFF95"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.7695,
    y: 14.1023,
    width: 3.31151,
    height: 15.7934,
    transform: "rotate(45 25.7695 14.1023)",
    fill: "#19292C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 21.6675,
    width: 3.31151,
    height: 8.40615,
    transform: "rotate(-45 11 21.6675)",
    fill: "#19292C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGreenDark);
export default __webpack_public_path__ + "static/media/check-circle-green-dark.4c3b93ecca0e92238406b5cef9ba5938.svg";
export { ForwardRef as ReactComponent };